var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-main',{staticClass:"walletContainer"},[_c('div',[_c('div',[_c('h1',[_vm._v("Notifications")]),_c('v-card',{staticClass:"transactionCard",attrs:{"flat":""}},[(
            !_vm.isNotifications &&
            (_vm.userNotifications == undefined ||
              (_vm.userNotifications && _vm.userNotifications.length == 0))
          )?_c('div',[_c('EmptyNotification')],1):_vm._e(),_c('NotificationItem',{attrs:{"userNotifications":_vm.userNotifications}}),(_vm.isNotifications)?_c('div',[_c('notifications-loading')],1):_vm._e()],1)],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }